/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanityAnalyticsTrxFeeRequest = {
    period?: HumanityAnalyticsTrxFeeRequest.period;
};

export namespace HumanityAnalyticsTrxFeeRequest {

    export enum period {
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
        ALL = 'ALL',
    }


}

